import { withI18nPlaceholders } from '@change-corgi/core-react/i18n';

import I18N_PLACEHOLDERS from '#config/i18n/placeholders/login-or-join-sap-cycling-proof/login-or-join-sap-cycling-proof.yml';

import { LoginOrSignup as LoginOrSignupPage } from './entryPoint';

export const LoginOrSignup = withI18nPlaceholders(I18N_PLACEHOLDERS, LoginOrSignupPage);
